// extracted by mini-css-extract-plugin
module.exports = {"ScopesInspector":"ScopesInspector_ScopesInspector__EEXD_","Expandable":"ScopesInspector_Expandable__c1TrE"};